// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.PDP.RecentlyViewed.MainView'
,	[
	  'c3_shoppingextensions_pdp_recentlyview_main.tpl'
	,   'C3.ShoppingExtensions.CartPage.RecentlyView'
    ,   'Utils'
    ,   'RecentlyViewedItems.Collection'
    ,   'C3.ShoppingExtensions.PDP.SetsIncluded.Item.View'
    ]
, function (
	   c3_shoppingextensions_pdp_recentlyview_main_tpl
	,   RecentlyView
    ,  Utils
    ,  RecentlyViewedItemsCollection
    ,  PDPRecentlyView
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_pdp_recentlyview_main_tpl

	,	initialize: function (options) {
		    this.options = options;
			//console.log(this.options)
			this.application = options.application;
			//this.layout = options.layout;
			this.configuration = options.configuration;
			this.container = options.container;
			//this.itemsIds = options.itemsIds;

			this.collection = RecentlyViewedItemsCollection.getInstance();

			this.finalizedRecentlyViewedArray = []

			var self = this;

			if(this.collection && this.collection.models)
			{
				var collection_models = this.collection.models;
				//console.log(collection_models)

				_.each(collection_models,function(collec){
					self.finalizedRecentlyViewedArray.push(collec.get('internalid'))
				});
			}

			//console.log(this.finalizedRecentlyViewedArray)
		}


	,   events: {
    	'click [data-action="pdp-setsincluded-click"]': 'arrowClicked'
    }
    
    ,   arrowClicked: function arrowClicked(e){
    	
    	const anchor = jQuery(e.currentTarget)
    	,     data_attr = anchor.attr('data-click')
	    ,     sibling = anchor.siblings()

	    //console.log(anchor)
	    if(data_attr == 'right-click')
	    {
	    	//console.log(anchor.hasClass('disabled'))
	    	//console.log(sibling.hasClass('disabled'))
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}

	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')	    		
	    	}
	    	else
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
	    	}
	    }
	    else if(data_attr == 'left-click')
	    {
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
	    	
	    	}
	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}
	    	else
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
	    	}
	    }
	   
    }	

	, 	childViews: {
			'PDP.Recently.Viewed': function ()
      		{
     			var self = this;
     			//console.log(this.application)
     			return new PDPRecentlyView({
				  	application: this.application,
				  	container : this.container,
				  	itemsIds : this.finalizedRecentlyViewedArray,
				  	configuration : this.configuration,
				  	origin : 'RecentlyViewedPDP'
				  });

      		}
		}


		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{

			return {
				hasRecentlyViewed : this.collection && this.collection.models.length > 0
			};
		}
	});
});
